module.exports = __webpack_public_path__ + "static/the-good-tree-logo-00f2ed5da662b29bf4dffac95c2a07f5.svg";